import request from '@/utils/request'
/**
 * 资格审查
 * */
// 列表
export const qualificationReviewList = (data) => {
  return request.get('/api/agent/qualificationReview/list?projectCode='+ data.projectCode +'&pageNum='+ data.pageNum +'&pageSize='+ data.pageSize+'&stage='+ data.stage+'&bidSectionName='+ data.bidSectionName)
}
//新增-修改资格审查内容
export const qualificationReviewAdd = (data) => {
  return request.post('/api/agent/qualificationReview/add', data)
}
// 获取资格审查内容
export const qualificationReviewDetail = (data) => {
  return request.get('/api/agent/qualificationReview/detail?bidSectionCode='+ data.bidSectionCode)
}
//资格审查结果
export const qualificationReviewResultDetail = (data) => {
  return request.get('/api/agent/qualificationReview/resultDetail?bidSectionCode='+ data.bidSectionCode)
}
// 保存资格审查结果
export const qualificationReviewAddResult = (data) => {
  return request.post('/api/agent/qualificationReview/addResult', data)
}

